import { Api } from "@rhema/client";
import { deviceName } from "../session/device";
import { webHasShareSheet, webShare } from "./share";
import { idbUploadSpool } from "./spool";
import type { Platform } from "./types";

/** The browser: same-origin API, httpOnly session cookie, keys in IndexedDB. */
export function createWebPlatform(api: Api = new Api()): Platform {
  return {
    kind: "web",
    native: false,
    device: "web",
    authClient: "web",
    api,
    deviceName: () => deviceName(),
    serverOrigin: () => "",
    defaultServerOrigin: "",
    setServerOrigin: async () => {
      throw new Error("The web app always uses the server it was loaded from.");
    },
    clientOptions: (userId) => ({ uploadSpool: idbUploadSpool(userId) }),
    saveToken: async () => {},
    signInWith: async () => {
      throw new Error("The web app signs in with a redirect.");
    },
    openExternal: async (url) => {
      window.location.assign(url);
    },
    share: webShare,
    hasShareSheet: webHasShareSheet,
    onSignedIn: () => () => {},
    signOut: async () => {
      try {
        const res = await api.logout();
        return res?.logout_url || "/sign-in";
      } catch {
        // Already signed out on the server. Clear this device anyway.
        return "/sign-in";
      }
    },
    attach: () => () => {},
  };
}
